import { combineEpics } from 'redux-observable';
import { helpEpics } from './views/Help/epics/HelpEpics';
export const rootEpic = combineEpics(helpEpics);
export default rootEpic;

//# sourceMappingURL=epics.js.map
